import React, { useState } from "react";
import { Search } from "lucide-react";
import { COMPETENCIES, TECH_STACK } from "../data/content";
import { Eyebrow, Reveal } from "./shared";
import { LeafSchematic, PlanetDot } from "./motifs";

export default function Skills() {
  const [q, setQ] = useState("");
  const filtered = TECH_STACK.filter((t) => t.toLowerCase().includes(q.toLowerCase()));
  return (
    <section id="skills" className="relative py-24 sm:py-32 bg-linen overflow-hidden">
      {/* engineering botanical schematic, decorative */}
      <div className="pointer-events-none absolute -right-8 top-16 hidden lg:block" aria-hidden>
        <LeafSchematic className="w-56 h-72" stroke="#B08830" opacity={0.22} />
      </div>
      <div className="pointer-events-none absolute inset-0 constellation-grid opacity-25" aria-hidden />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <Eyebrow n={5} className="mb-12">Skills</Eyebrow>
        </Reveal>
        <div className="grid lg:grid-cols-2 gap-14">
          <Reveal>
            <div className="flex items-center gap-3 mb-2">
              <PlanetDot />
              <span className="font-mono-tech text-[10px] tracking-[0.28em] uppercase text-brass">
                Core Competencies · Instrument Panel
              </span>
            </div>
            <h3 className="font-display text-3xl sm:text-4xl font-light text-caramel mb-8">Core competencies</h3>
            <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-4" data-testid="competency-list">
              {COMPETENCIES.map((c, i) => (
                <li key={c} className="flex items-start gap-3 text-caramel/85">
                  <span className="mt-1 font-mono-tech text-[10px] tracking-widest text-brass shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span>{c}</span>
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="flex items-center gap-3 mb-2">
              <PlanetDot />
              <span className="font-mono-tech text-[10px] tracking-[0.28em] uppercase text-brass">
                Tools · Stack Registry
              </span>
            </div>
            <h3 className="font-display text-3xl sm:text-4xl font-light text-caramel mb-8">Tools & technology</h3>
            <div className="relative mb-6 max-w-sm">
              <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-warmmuted" />
              <input
                data-testid="tech-search"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Search tools, e.g. Salesforce"
                className="w-full rounded-full border border-border bg-ivory pl-11 pr-4 py-3 text-caramel placeholder:text-warmmuted/70 outline-none focus:border-terracotta transition-colors"
              />
            </div>
            <div className="flex flex-wrap gap-2.5" data-testid="tech-chips">
              {filtered.map((t) => (
                <span
                  key={t}
                  className="font-mono-tech text-xs rounded-full px-3.5 py-2 bg-ivory/90 text-caramel border border-brass/30 hover:border-terracotta hover:text-terracotta hover:-translate-y-0.5 transition-all"
                >
                  {t}
                </span>
              ))}
              {filtered.length === 0 && (
                <span className="text-warmmuted italic">No tools match "{q}".</span>
              )}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
